import { create } from "zustand";
import type { IAnchorRect } from "@/components/widgets/tradeActionSummary/helper/cellRenderers/MainTableActionSummaryESLevel/ExpiresCellRenderer/expiryEditHelpers";

// LQC-2678 - transient target for the edit-expiry popover, so the AG Grid
// right-click menu can open it. Menu items are plain objects outside React and
// cannot render the popover themselves.
//
// `cryptoID` scopes the target to one blotter: every ActionSummaryTable (main
// grid, trade tiles, pop-outs) mounts its own host, and without this they would
// all open at once. Type-only import of IAnchorRect - a value import would pull
// the widget cycle into the store.

export interface IExpiryEditTarget {
  esid: string;
  anchorRect: IAnchorRect;
  cryptoID: string | undefined;
}

type State = {
  target: IExpiryEditTarget | null;
  openExpiryEdit: (target: IExpiryEditTarget) => void;
  closeExpiryEdit: () => void;
};

const expiryEditStore = create<State>((set) => ({
  target: null,
  openExpiryEdit: (target) => set({ target }),
  closeExpiryEdit: () => set({ target: null }),
}));

export default expiryEditStore;
